import React from 'react';

import './Decline.css';
import { useCommon } from '../../store/CommonContext';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';

interface Props {}

const Decline: React.FC<Props> = props => {
  const {
    state: { configurationLoading, orderDataLoading, configuration, orderData },
  } = useCommon();

  return (
    <div className="ui-widget-challenge" style={{ fontFamily: 'Helvetica', borderRadius: '0px' }}>
      <form className="ui-widget-challenge-form">
        <div
          className="ui-widget-dialog"
          id="ui-widget-dialog"
          style={{
            ...(configuration?.fontFamily && { fontFamily: configuration.fontFamily as string }),
            ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
          }}
        >
          <div className="ui-widget-logo-wrapper"></div>
          <div className="ui-widget-content ui-widget-content-challenge">
            <div className="no-margin-bottom">
              <div className="">
                <h1 className="ui-widget-title" style={{ color: 'rgb(29, 29, 40)' }}>
                  Unfortunately we could not solve the issue with your payment method.
                </h1>
                <div className="ui-widget-separator-horizontal"></div>
                <div className="ui-widget-row">
                  <div className="ui-widget-col-12 ui-widget-first-item ui-widget-last-item">
                    <ul className="ui-widget-list">
                      <li className="ui-widget-list-item " style={{ color: 'rgb(29, 29, 40)' }}>
                        Your payment failed. You have not been charged.
                      </li>
                      <li className="ui-widget-list-item " style={{ color: 'rgb(29, 29, 40)' }}>
                        You will be redirected back to the checkout page.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<div className="ui-widget-row">*/}
          {/*  <div className="ui-widget-terms ui-widget-first-item ui-widget-last-item">*/}
          {/*    <span className="">Governed by FlexCharge </span>*/}
          {/*    <a*/}
          {/*      className=" ui-widget-link"*/}
          {/*      href="https://www.flex-charge.com/flexcharge-end-user-terms-of-service"*/}
          {/*      target="_blank"*/}
          {/*      rel="noreferrer"*/}
          {/*    >*/}
          {/*      Terms and Conditions*/}
          {/*    </a>*/}
          {/*    <span className=""> and </span>*/}
          {/*    <a*/}
          {/*      className=" ui-widget-link"*/}
          {/*      href="https://www.flex-charge.com/privacy-policy"*/}
          {/*      target="_blank"*/}
          {/*      rel="noreferrer"*/}
          {/*    >*/}
          {/*      Privacy Notice*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </form>
    </div>
  );
};

export default Decline;
